import { render, staticRenderFns } from "./startAndEndWork.vue?vue&type=template&id=486d94b4"
import script from "./startAndEndWork.vue?vue&type=script&lang=js"
export * from "./startAndEndWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports